module.exports = __webpack_public_path__ + "img/logo_yidong.371d4405.png";